var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_62",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 25.6608C17.3536 25.6608 13.5696 21.8768 13.5696 17.2304C13.5696 12.584 17.3536 8.79999 22 8.79999C26.6464 8.79999 30.4304 12.584 30.4304 17.2304C30.4304 21.8768 26.6464 25.6608 22 25.6608ZM22 11.2024C18.6824 11.2024 15.9808 13.904 15.9808 17.2216C15.9808 20.5392 18.6824 23.2408 22 23.2408C25.3176 23.2408 28.0192 20.5392 28.0192 17.2216C28.0192 13.904 25.3176 11.2024 22 11.2024Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0472 35.2968H31.636C31.636 29.9816 27.3152 25.6608 22 25.6608C16.6848 25.6608 12.364 29.9816 12.364 35.2968H9.95279C9.95279 28.6528 15.356 23.2496 22 23.2496C28.644 23.2496 34.0472 28.6528 34.0472 35.2968Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_62)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.75998,
    y: -3.51999,
    width: 56.32,
    height: 59.84,
    fill: "#DBE9F6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabProfileIcon);
export default __webpack_public_path__ + "static/media/tabProfileIcon.902494abe3d91f4254b9b9ecbc16410e.svg";
export { ForwardRef as ReactComponent };